const MEDIA_SOURCES_MAP = [
  {
    name: "youtube",
    keywords: ["youtube"]
  },
  {
    name: "facebook",
    keywords: ["facebook", "fb.com"]
  },
  {
    name: "twitter",
    keywords: ["twitter", "x.com"]
  },
  {
    name: "linkedin",
    keywords: ["linkedin"]
  },
  {
    name: "instagram",
    keywords: ["instagram"]
  },
  {
    name: "telegram",
    keywords: ["telegram.me", "t.me"]
  }
];
function mapSocialLinks(socialLinks) {
  const oldSocialList = socialLinks?.map((socialItem) => {
    const iconName = MEDIA_SOURCES_MAP.find((source) => source.keywords.some((keyword) => socialItem.url.includes(keyword)))?.name || "";
    return {
      src: socialItem.url,
      name: iconName
    };
  });
  const socialList = oldSocialList?.length ? ["instagram", "facebook", "twitter", "youtube", "linkedin", "telegram"].flatMap((socialName) => oldSocialList.filter((socialItem) => socialItem.name === socialName)) : [];
  return socialList;
}
export {
  mapSocialLinks as default
};
